import Avatar, { AvatarProps } from './Avatar';

export type TeamLogo = {
  webp?: string;
  url?: string;
};

export type TeamAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  logo?: TeamLogo | null;
  name: string;
};

export default function TeamAvatar({ logo, name, onError, ...props }: TeamAvatarProps) {
  return <Avatar srcs={[logo?.webp, logo?.url]} alt={name} onError={onError} coloredBackground {...props} />;
}
